import styleInject from '../../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".desktop-library--wtRar {\n  position: absolute;\n  top: -7.2rem;\n  right: 0;\n  height: 5.6rem;\n  width: 5.6rem;\n  line-height: 0;\n  background-color: #d4d4d4;\n  border-radius: 50%;\n  display: inline-block;\n}\n@media screen and (max-width: 750px) {\n  .desktop-library--wtRar {\n    visibility: hidden;\n  }\n}\n\n@media screen and (min-width: 751px) {\n  .mobile-library--TMdWt {\n    background-color: white;\n    visibility: hidden;\n  }\n}";
var styles = {"desktop":"desktop-library--wtRar","mobile":"mobile-library--TMdWt"};
styleInject(css_248z);

export { styles as default };
